import {FC, useState} from 'react'
import {useBetween} from 'use-between'
import {Button} from '../../../utils/Button'
import {propsInterfaceFormGroupInput} from '../../../utils/form/FormGroupInput'
import {BTCreateContract2} from '../BTContract/BTCreateContract2'
import {ModalForm} from '../../../utils/modal/ModalForm'
import {AlertModal} from '../../../utils/modal/AlertModal'

const ActionDataGrid2: FC<actionDataGridProps> = (props) => {
  const [showModalMenu, setShowModalMenu] = useState(false)
  const [showConfirm, setShowConfirm] = useState(false)
  const {deleteRow, dataModelo, setDataModelo, addRowStructure, updateRow} =
    useBetween(BTCreateContract2)
  const columInput = 3
  const [arrayInput] = useState<propsInterfaceFormGroupInput[]>([
    {
      columInput: columInput,
      campo: 'fatherStructure',
      label: 'Estructura Padre',
      type: 'autocomplete',
      advanceOptions: {
        id: 'fatherStructure',
        multiple: false,
        options: [
          {text: 'Plato de fondo', value: '1'},
          {text: 'Entrada', value: '2'},
          {text: 'Postre', value: '3'},
          {text: 'Acompañamiento', value: '4'},
        ],
      },
      onChange: (item: any) => {
      },
      className: 'form-control form-control-lg step-2',
    },
    {
      columInput: columInput,
      campo: 'tolerance',
      label: 'Intolerancia',
      placeholder: 'Ingrese Intolerancia',
      type: 'autocomplete',
      advanceOptions: {
        id: 'tolerance',
        multiple: false,
        options: [
          {text: 'Sin filtro', value: '1'},
          {text: 'Lactosa', value: '2'},
          {text: 'Gluten', value: '3'},
        ],
      },
      className: 'form-control form-control-lg',
    },
    {
      columInput: columInput,
      campo: 'allergens',
      label: 'Permite Alergenos',
      placeholder: 'Seleccione Alergenos',
      type: 'autocomplete',
      advanceOptions: {
        id: 'allergens',
        multiple: false,
        options: [
          {text: 'Mariscos', value: '1'},
          {text: 'Frutos Secos', value: '2'},
          {text: 'Pescado', value: '3'},
        ],
      },
      className: 'form-control form-control-lg',
    },
    {
      columInput: columInput,
      campo: 'structure',
      label: 'Estructura',
      type: 'text',
      className: 'form-control form-control-lg',
    },
    {
      columInput: columInput,
      campo: 'allowsStamp',
      label: 'Permite Sellos',
      type: 'autocomplete',
      advanceOptions: {
        id: 'allowsStamp',
        multiple: false,
        options: [
          {text: 'Si', value: '1'},
          {text: 'No', value: '2'},
        ],
      },
      className: 'form-control form-control-lg',
    },
  ])

  return (
    <>
      <Button
        className='btn-table'
        onClick={() => {
          setShowConfirm(true)
        }}
        type='button'
      >
        <i className='bi bi-trash3-fill icon-action'></i>
      </Button>

      {showModalMenu && (
        <ModalForm
          initialValues={dataModelo}
          show={showModalMenu}
          onSubmit={(_value, formikProps) => {
            setTimeout(() => {
              setDataModelo(props.dataRow)
              updateRow(formikProps.values)
              setShowModalMenu(false)
            }, 500)
          }}
          close={() => {
            setShowModalMenu(false)
          }}
          save={() => {
          }}
          title={'Editar estructura contrato'}
          arrayInput={arrayInput}
        />
      )}

      {showConfirm && (
        <AlertModal
          title={'Alerta'}
          message={'¿Esta seguro de eliminar?'}
          saveName='Eliminar'
          save={() => {
            deleteRow(props)
            setShowConfirm(false)
          }}
          show={showConfirm}
          close={() => {
            setShowConfirm(false)
          }}
        />
      )}
    </>
  )
}
interface actionDataGridProps {
  edit?(): void
  delete?(): void
  dataRow?: any
}
export {ActionDataGrid2}
